module.exports = __webpack_public_path__ + "img/canbadge_rokkaku_65mm.0404df1b.png";